import { memo } from "react";
import { equals } from "ramda";
import { RemoveUnit, DrillButton, Value, Td } from "./organizationslist.styles";
import { measureCodeExplanations } from "utils/measurement";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function OrganizationRow(props) {
  var organization = props.organization,
    values = props.values,
    removeOrganization = props.removeOrganization,
    drilldown = props.drilldown,
    measure = props.measure,
    disableUnitsInteraction = props.disableUnitsInteraction,
    color = props.color;
  var valuesMarkup = values.map(function (value, idx) {
    var code = measureCodeExplanations(value);
    var title = code ? code : undefined;
    return /*#__PURE__*/_jsx(Value, {
      title: title,
      values: values.length,
      children: value
    }, idx);
  });
  var hasTail = organization === null || organization === void 0 ? void 0 : organization.hasTail;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Td, {
      "aria-colindex": "1",
      children: /*#__PURE__*/_jsx(RemoveUnit, {
        "aria-label": "Ta bort ".concat(organization === null || organization === void 0 ? void 0 : organization.name),
        className: "remove-pre-png",
        color: color,
        disableUnitsInteraction: disableUnitsInteraction,
        disabled: disableUnitsInteraction,
        onClick: function onClick() {
          return removeOrganization(organization === null || organization === void 0 ? void 0 : organization.id);
        }
      })
    }), /*#__PURE__*/_jsx(Td, {
      "aria-colindex": "2",
      title: organization === null || organization === void 0 ? void 0 : organization.name,
      children: /*#__PURE__*/_jsx(DrillButton, {
        "aria-label": hasTail ? "V\xE4lj enheter inom ".concat(organization === null || organization === void 0 ? void 0 : organization.name) : undefined,
        disabled: !hasTail,
        onClick: function onClick() {
          return drilldown(measure.measureId, organization === null || organization === void 0 ? void 0 : organization.id);
        },
        children: organization === null || organization === void 0 ? void 0 : organization.name
      })
    }), /*#__PURE__*/_jsx(Td, {
      "aria-colindex": "3",
      children: /*#__PURE__*/_jsx("div", {
        children: valuesMarkup
      })
    })]
  });
}, function (prev, curr) {
  return equals(prev.color, curr.color) && equals(prev.values, curr.values) && equals(prev.measure, curr.measure) && equals(prev.disableUnitsInteraction, curr.disableUnitsInteraction);
});